import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { VARIATION_EXPORT_INFO_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation PublishVariations(
    $variationIds: [ID!]!
    $assetName: String!
    $accountId: ID!
    $dataSource: PerformanceCenterDataSource!
  ) {
    publishVariations(
      variationIds: $variationIds
      assetName: $assetName
      accountId: $accountId
      accountDataSource: $dataSource
    ) {
      id
      exportInfo {
        ...VariationExportInfo
      }
    }
  }
  ${VARIATION_EXPORT_INFO_FRAGMENT}
`;

export const publishVariations = ({ variationIds, dataSource, accountId, assetName }) => {
  const variables = { variationIds, dataSource, accountId, assetName };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
